<script lang="ts">
import { defineBlock } from '@bagelink/blox'
import { defineSchema, $ } from '@bagelink/vue'
const defaults = {
	title: 'Categories',
	items: [{ label: 'Category One' }],
}
const schema = defineSchema({
	title: $.text('Title'),
	items: $.array(
		'Items',
		defineSchema({
			label: $.text('Label'),
			slug: $.text('Link'),
		}),
		{ collapsible: true },
	),
})
export const CategoriesList = defineBlock({
	pickerHidden: true,
	thumbnail: '/block-thumbs/CategoriesList.svg',
	category: 'Listings',
	order: 310,
	name: 'CategoriesList',
	label: 'Categories List',
	icon: 'category',
	schema,
	defaults,
})
</script>
<script setup lang="ts">


defineProps<{
	title?: string
	items?: { label: string; slug?: string }[]
}>()
</script>

<template>
	<div class="border-bottom border-top flex column pt-1 pb-1 gap-025">
		<h4 v-if="title" class="color-black-50 regular m-0 txt13">
			{{ title }}
		</h4>
		<RouterLink
			v-for="category in items?.filter(item => item.slug)"
			:key="category.slug"
			:to="category.slug!"
			class="txt15 color-gray-70 decoration-none hover-opacity-7"
		>
			{{ category.label }}
		</RouterLink>
	</div>
</template>
